import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Checkbox, Form, Input } from 'antd';
import _ from 'lodash';
import ExtendedSelect from 'components/extendedSelect/extended-select';
import settings from 'settings';
import { convertToSelect, getKey, getLabel } from 'library/helpers';
import { list } from 'actions';
import REDUCER_KEY from 'reducers/reducer.keys';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;

const mapStateToProps = state => ({
  locations: state.api.travelLocations.data.results,
  routeTypes: state.api.travelRouteTypes.data.results,
  travelModes: typeof state.api.travelModes.data.results !== 'undefined' ? [] : state.api.travelModes.data // api returns different types
});

const mapDispatchToProps = dispatch => ({
  loadRouteTypes(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }
    filters.push({
      id: 'active',
      value: true
    });

    return dispatch(list(REDUCER_KEY.travelRouteTypes.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  },
  loadLocations(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }
    filters.push({
      id: 'active',
      value: true
    });
    return dispatch(list(REDUCER_KEY.travelLocations.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  },
  loadTravelModes(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }
    filters.push({
      id: 'active',
      value: true
    });
    return dispatch(list(REDUCER_KEY.travelModes.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  }
});

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const {
    active, route_type, name, travel_mode, departure_location, arrival_location, type
  } = dataSource;

  const routeType = route_type && !route_type.key
    ? {
      id: route_type,
      name: type
    }
    : route_type;

  return {
    name: Form.createFormField({ value: name }),
    route_type: Form.createFormField({ value: convertToSelect(routeType) }),
    travel_mode: Form.createFormField({ value: travel_mode }),
    departure_location: Form.createFormField({ value: convertToSelect(departure_location) }),
    arrival_location: Form.createFormField({ value: convertToSelect(arrival_location) }),
    active: Form.createFormField({ value: active })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

class FormInput extends Component {
  componentDidMount() {
    const { loadRouteTypes, form, itemId } = this.props;
    if (itemId === -1) {
      loadRouteTypes()
        .then(() => {
          form.resetFields();
        });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { itemId, form } = nextProps;
    if (itemId === -1 && !form.getFieldValue('route_type')) {
      form.resetFields();
    }
  }

  render() {
    const {
      canAdmin, checkboxFormItemLayout, dataSource, inputFormItemLayout, form, locations, loadLocations, routeTypes, loadRouteTypes, travelModes, loadTravelModes
    } = this.props;
    const { getFieldDecorator } = form;
    const {
      active, route_type, name, travel_mode, departure_location, arrival_location, type
    } = dataSource;
    // build Route Type
    let routeType = route_type && !route_type.key
      ? {
        key: route_type,
        label: type
      }
      : route_type;
    if (!routeType && routeTypes[0]) {
      routeType = {
        key: routeTypes[0].id,
        label: routeTypes[0].name
      };
    }
    const readonly = !canAdmin;
    return (
      <Form>
        <FormItem {...inputFormItemLayout} label="Route Name">
          {getFieldDecorator('name', {
            initialValue: name,
            rules: [{
              required: true,
              message: 'Please enter the Route Name.'
            }]
          })(<Input maxLength={255} disabled={readonly} />)}
        </FormItem>
        <FormItem {...inputFormItemLayout} label="Route Type">
          {getFieldDecorator('route_type', {
            initialValue: routeType,
            rules: [{
              required: true,
              message: 'Please enter the Route Type.'
            }]
          })(
            <ExtendedSelect
              placeholder="Select Route Type"
              dataSource={routeTypes}
              optionKey={getKey}
              optionLabel={getLabel}
              disabled={readonly}
              onSearch={loadRouteTypes}
              onFocus={loadRouteTypes}
            />
          )}
        </FormItem>
        <FormItem {...inputFormItemLayout} label="Travel Mode">
          {getFieldDecorator('travel_mode', {
            initialValue: travel_mode,
            rules: [
              {
                required: true,
                message: 'Please enter the Travel Mode.'
              }
            ]
          })(
            <ExtendedSelect
              placeholder="Select Travel Mode"
              dataSource={travelModes}
              disabled={readonly}
              optionKey={item => item.key}
              optionLabel={item => item.value}
              onSearch={loadTravelModes}
              onFocus={loadTravelModes}
              labelInValue={false}
            />
          )}
        </FormItem>
        <FormItem {...inputFormItemLayout} label="Depart From">
          {getFieldDecorator('departure_location', {
            initialValue: departure_location,
            rules: [
              {
                required: true,
                message: 'Please enter the Departure Location.'
              }
            ]
          })(
            <ExtendedSelect
              placeholder="Select Location"
              dataSource={locations}
              optionKey={getKey}
              optionLabel={item => `${item.name} (${item.code})`}
              disabled={readonly}
              onSearch={loadLocations}
              onFocus={loadLocations}
            />
          )}
        </FormItem>
        <FormItem {...inputFormItemLayout} label="Arrive In">
          {getFieldDecorator('arrival_location', {
            initialValue: arrival_location,
            rules: [
              {
                required: true,
                message: 'Please enter the Arrival Location.'
              }
            ]
          })(
            <ExtendedSelect
              placeholder="Select Location"
              dataSource={locations}
              optionKey={getKey}
              optionLabel={item => `${item.name} (${item.code})`}
              disabled={readonly}
              onSearch={loadLocations}
              onFocus={loadLocations}
            />
          )}
        </FormItem>
        <FormItem {...checkboxFormItemLayout}>
          {getFieldDecorator('active', {
            initialValue: active,
            valuePropName: 'checked'
          })(<Checkbox disabled={readonly}>Active</Checkbox>)}
        </FormItem>
      </Form>
    );
  }
}

FormInput.propTypes = {
  itemId: PropTypes.number.isRequired,
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  loadRouteTypes: PropTypes.func,
  loadLocations: PropTypes.func,
  loadTravelModes: PropTypes.func,
  locations: PropTypes.array,
  routeTypes: PropTypes.array,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func,
  travelModes: PropTypes.array
};

FormInput.defaultProps = {
  canAdmin: false,
  checkboxFormItemLayout: {},
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  loadRouteTypes() {
  },
  loadLocations() {
  },
  loadTravelModes() {
  },
  locations() {
  },
  routeTypes: [],
  onFieldsChange() {
  },
  onValuesChange() {
  },
  travelModes: []
};

const ConnectedFormInput = connect(mapStateToProps, mapDispatchToProps)(FormInput);

const RouteFormInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(ConnectedFormInput));

export default RouteFormInput;
